import React, { createContext, ReactNode } from 'react'
import { IShipmentResultFragment } from 'apps/marketplace/pages/shipment-details/components/ShipmentProgress/components/StopBasicInfo/AddTrailer/ShipmentAutosuggest/graphql/ShipmentResultFragment'

type OriginalShipmentContextState = {
  shipment: IShipmentResultFragment | null
  isLoading: boolean
}

/**
 * Init the context
 */
export const originalShipmentDefaultState: OriginalShipmentContextState = {
  shipment: null,
  isLoading: false,
} as OriginalShipmentContextState

// Creates the context object that we'll pass into components
export const OriginalShipmentContext = createContext<OriginalShipmentContextState>(
  originalShipmentDefaultState
)

interface IOriginalShipmentProviderProps {
  children: ReactNode
  defaultValues: IShipmentResultFragment | null
}

/**
 * Provide default Provider state component to wrap around app
 */
export const OriginalShipmentProvider: React.FC<IOriginalShipmentProviderProps> = ({
  children,
  defaultValues,
}): JSX.Element => {
  return (
    <OriginalShipmentContext.Provider
      value={{
        shipment: defaultValues,
        isLoading: false,
      }}>
      {children}
    </OriginalShipmentContext.Provider>
  )
}
